import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import BadgesDisplay from '../components/BadgesDisplay';
import { useTheme } from '../context/ThemeContext';

/**
 * Badges Page - Dedicated page for viewing all badges
 */
const Badges = () => {
  const navigate = useNavigate();
  const { theme } = useTheme();

  return (
    <div className="min-h-screen" style={{ backgroundColor: theme?.colors?.background || '#f8f5ff' }}>
      {/* Header */}
      <div className="sticky top-0 bg-white border-b border-gray-100 z-10">
        <div className="max-w-lg mx-auto px-4 py-3 flex items-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="p-2 -ml-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-full"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <h1 className="text-lg font-semibold text-gray-900">Achievements</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-lg mx-auto p-4">
        <BadgesDisplay />
      </div>
    </div>
  );
};

export default Badges;
